import React, { useCallback } from "react";
import ReactModal, { Styles } from "react-modal";
import { useKeyPressEvent } from "../hooks";

interface Props {
  isOpen: boolean;
  onTriggerClose: () => void;
  children?: React.ReactNode | React.ReactNode[];
  style?: Styles;
}

function Modal({ isOpen, onTriggerClose, children, style }: Props) {
  const handleKeyEvent = useCallback((event: KeyboardEvent) => {
    if (event.key === "Escape") {
      onTriggerClose();
    }
  }, []);

  useKeyPressEvent(
    {
      id: "modal",
      priority: 1,
      useCallbackGeneratedCB: handleKeyEvent,
    },
    isOpen
  );

  return (
    <ReactModal
      style={style}
      isOpen={isOpen}
      onRequestClose={onTriggerClose}
      //TODO: don't do this - it's b/c I'm not rendering WopQuery
      //atow to not trigger too many queries
      ariaHideApp={false}
      shouldCloseOnEsc
    >
      {children}
    </ReactModal>
  );
}

export default Modal;
